
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeInicio } from './controlador';
    import inicio from './control-bultos.vue';
    import finalizar from './control-bultos-finalizar.vue';
    import { settings, Wait } from '@ext/index';
    const AudioNotificacionOK = settings.URL.static + '/lectora_ok.mp3';
    const AudioNotificacionMAL = settings.URL.static + '/lectora_error.mp3';


    @Component( {
        name: "Componente",
        props: {},
        components: {
            inicio,
            finalizar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public ControladorPrincipal: ControladorDeInicio;
        public Controlador: ControladorDeInicio = null;

        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }
        public AudioNotificacionOK = '';
        public AudioNotificacionMAL = '';

         
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Controlador.onSona.subscribe( async (x) =>
            {
                if ( x )
                {
                    document.getElementById( 'notif_ok' ).play();
                } else
                {
                    document.getElementById( 'notif_mal' ).play();
                    //await Wait(400)
                    //document.getElementById( 'notif_ok' ).play();
                }
            } ) );

            this.AudioNotificacionOK = AudioNotificacionOK;
            this.AudioNotificacionMAL = AudioNotificacionMAL;
        }

        async created()
        {
            this.Controlador = new ControladorDeInicio();
            await this.Controlador.Iniciar();
        }

    
    }
